// Frontend defense-in-depth scope-helper. Spiegelt de logica van
// backend/src/middleware/scope.js maar werkt met de user-vorm zoals die uit
// /api/auth/me komt (camelCase: energyLabel, salesTeam, sellerName).
//
// De server is de bron van waarheid; deze helper voorkomt dat CSV-uploads
// (die alleen admin kan doen, maar tijdens impersonate ook door lagere rollen
// te zien zijn) per ongeluk data buiten scope tonen in tabel, exports,
// dashboards, zoekfuncties of detailpagina's.

export function matchesUserScope(user, row) {
  if (!user) return false;
  // admin én ET Dossierbeheerder hebben volledige data-toegang.
  if (user.role === 'admin' || user.role === 'et_dossier') return true;
  // Order-velden EN factuur-velden ondersteunen — beide datatypes lopen door
  // deze filter.
  const label = row.company ?? row.relatieBedrijf ?? '';
  const team = row.salespersonTeam ?? row.verkoopteam ?? '';
  const seller = row.salesperson ?? row.verkoper ?? '';
  // Merk-afscherming (defense-in-depth, zie CLAUDE.md): niet-admin/niet-et_dossier
  // mogen NOOIT rijen van de Odoo-entiteit "Energy Together" zien, ongeacht hun
  // eigen energyLabel.
  if (/energy\s*together/i.test(label)) return false;
  // Per-gebruiker vlag "toon alle orders": label-brede toegang (zoals master),
  // ongeacht team/verkoper. De server is de poortwachter (orders worden al
  // label-breed geleverd); deze client-filter mag dus net zo ruim zijn.
  if (user.viewAllLabelOrders) {
    return Boolean(user.energyLabel) && label === user.energyLabel;
  }
  // Prospect: leest als een master; zijn energyLabel én de rijen dragen dezelfde
  // (door de server vertaalde) naam van het potentiële label.
  if (user.role === 'master' || user.role === 'prospect_label' || user.role === 'prospect_reseller') {
    return Boolean(user.energyLabel) && label === user.energyLabel;
  }
  if (user.role === 'teamleader') {
    return Boolean(user.energyLabel) && label === user.energyLabel
        && Boolean(user.salesTeam) && team === user.salesTeam;
  }
  if (user.role === 'reseller') {
    return Boolean(user.energyLabel) && label === user.energyLabel
        && Boolean(user.salesTeam) && team === user.salesTeam
        && Boolean(user.sellerName) && seller === user.sellerName;
  }
  return false;
}

export function scopeFilter(rows, user) {
  if (user && (user.role === 'admin' || user.role === 'et_dossier')) return rows;
  return (rows || []).filter(r => matchesUserScope(user, r));
}
